// App-Versionierung
export const APP_VERSION = 'v1.0.8';
